export class PortfolioUtilities {
  static $inject = ["iso4217", "$location", "$anchorScroll"];

  constructor(private iso4217: any, private $location: ng.ILocationService, private $anchorScroll: ng.IAnchorScrollService) { }

  formatCurrency(currencyCode: string) {
    var displayCode = currencyCode==null?' ': currencyCode.toUpperCase() + ' ';
    return displayCode;
  }

  getCurrencySymbol(currencyCode: string) {
    var currencySymbol = this.iso4217.getCurrencyByCode(currencyCode).symbol + ' ';
    return currencySymbol;
  }

  public scrollToElement(elementId: string) {
    var old = this.$location.hash();
    this.$location.hash(elementId);
    this.$anchorScroll();
    //reset to old to keep any additional routing logic from kicking in
    this.$location.hash(old);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/portfolio.utilities.ts